var OptionType = /*#__PURE__*/function (OptionType) {
  OptionType["ADVANCED_SETTINGS"] = "ADVANCED_SETTINGS";
  OptionType["AGGREGATIONS"] = "AGGREGATIONS";
  OptionType["AGGREGATION_EDIT"] = "AGGREGATIONS_EDIT";
  OptionType["CHART_BUILDER"] = "CHART_BUILDER";
  OptionType["CUSTOM_COLUMN_BUILDER"] = "CUSTOM_COLUMN_BUILDER";
  OptionType["QUICK_FILTERS"] = "QUICK_FILTERS";
  OptionType["ROLLUP_ROWS"] = "ROLLUP_ROWS";
  OptionType["SEARCH_BAR"] = "SEARCH_BAR";
  OptionType["SELECT_DISTINCT"] = "SELECT_DISTINCT";
  OptionType["TABLE_EXPORTER"] = "TABLE_EXPORTER";
  OptionType["VISIBILITY_ORDERING_BUILDER"] = "VISIBILITY_ORDERING_BUILDER";
  OptionType["CONDITIONAL_FORMATTING"] = "CONDITIONAL_FORMATTING";
  OptionType["CONDITIONAL_FORMATTING_EDIT"] = "CONDITIONAL_FORMATTING_EDIT";
  OptionType["GOTO"] = "GOTO";
  return OptionType;
}(OptionType || {});
/**
 * Key for a plugin-contributed sidebar entry, following the
 * `plugin:<plugin-name>:<id>` convention. Modeling it as a
 * template-literal type rather than a bare `string` keeps `OptionItemKey`
 * from collapsing to `string`, so `OptionType` autocomplete survives and
 * an un-namespaced key is rejected at compile time.
 */
/**
 * Identifier for a sidebar entry. Built-in entries use the closed
 * `OptionType` enum; plugin-supplied entries use a `PluginOptionKey`. The
 * page-switch distinguishes the two by the presence of `configPage` on the
 * `OptionItem`, not by inspecting the key.
 */
export default OptionType;
//# sourceMappingURL=OptionType.js.map